import React, { useRef, useState } from "react";
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { validateEmail } from "../../../utils";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";

const Portin = () => {
  const [msisdn, setmsisdn] = useState("");
  const [data, setData] = useState<any>([]);
  const [action, setAction] = useState(false);
  const [email, setEmail] = useState<string>("");
  const [product, setProduct] = useState<number>(1);
  const agGridRef = useRef<AgGridReact | null>(null);

  const handleClick = async () => {
    setData([]);
    toast.dismiss();

    if (msisdn.trim().length > 9 || email.trim() !== "") {
      if (email.trim() !== "" && !validateEmail(email.trim())) {
        toast.error("Please enter valid email address");
        return false;
      }
      setAction(true);
      await axiosInterceptorInstance
        .get(
          `/product?MSISDN=${msisdn.trim()}&Email=${email.trim()}&Product=${product}`
        )
        .then((res: any) => {
          setAction(false);
          const data = JSON.parse(res.data.body);
          if (data.userProducts.length > 0) {
            setData(data.userProducts);
          } else {
            setData({});
          }
        })
        .catch((error: any) => {
          setAction(false);
        });
    } else {
      toast.error("Please enter valid inputs.");
    }
  };
  const onGridReady = (params: { api: { sizeColumnsToFit: () => void } }) => {
    params.api.sizeColumnsToFit();
  };
  const columnDefs: ColDef[] = [
    {
      field: "NTMsisdn",
      headerName: "NTMsisdn",
      filter: true,
      sortable: true,
    },
    {
      field: "newmsisdn",
      headerName: "Newmsisdn",
      filter: true,
      sortable: true,
    },
    {
      field: "Email",
      headerName: "Email",
      filter: true,
      sortable: true,
    },
    {
      field: "SimStatus",
      headerName: "SimStatus",
      filter: true,
      sortable: true,
    },
  ];
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Account Details </h2>
        <div className="boxInner">
          <Grid container columnSpacing={2}>
            <Grid item xs={12}>
              <FormControl style={{ width: "50%", backgroundColor: "white" }}>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  className="formControl"
                  autoWidth
                  value={product}
                  defaultValue={product}
                  onChange={(e: any) => {
                    setProduct(parseInt(e.target.value));
                  }}
                >
                  <MenuItem value="1">THM</MenuItem>
                  <MenuItem value="2">Now</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container columnSpacing={2}>
            <Grid item xs={4.5}>
              <TextField
                className="formControl"
                label="NT-MSISDN"
                variant="outlined"
                value={msisdn}
                onChange={(e) => setmsisdn(e.target.value)}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>
            <Grid item xs={4.5}>
              <TextField
                className="formControl"
                label="Email"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                inputProps={{ maxLength: 100 }}
              />
            </Grid>
            <Grid item xs={3}>
              {!action && (
                <Button
                  onClick={handleClick}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
          {data.length > 0 && (
            <div className="ag-theme-alpine">
              <AgGridReact
                ref={agGridRef}
                paginationPageSize={10}
                pagination={true}
                domLayout="autoHeight"
                rowData={data}
                columnDefs={columnDefs}
                onGridReady={onGridReady}
                enableCellTextSelection={true}
              ></AgGridReact>
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default Portin;
